import { gql } from '@apollo/client'
import { TERRA_PROVIDER } from '@src/graphql/fragments/terraProvider'

export const FETCH_TERRA_PROVIDERS = gql`
  ${TERRA_PROVIDER}
  query allTerraProviders {
    allTerraProviders {
      providers {
        ...TerraProvider
      }
    }
  }
`
